export enum TaskState {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}
